import { Box } from "@mui/material";
import HomeTableSkeleton from "src/components/common/HomeTableSkeleton";
//import Box from "@mui/material/Box";
import { AxiosError, AxiosResponse } from "axios";
import { useMemo, useState, useEffect } from "react";
import { useQuery } from "react-query";
import { useDispatch } from "react-redux";
import {
  useNavigate,
  createSearchParams,
  Link as RouterLink,
  useSearchParams,
} from "react-router-dom";
import { DashboardWrapper } from "src/components/common/DashboardWrapper";
import { Button } from "src/components/common/FormComponents";
import HorizontalTabs from "src/components/common/HorizontalTabs";
import MultiSelect from "src/components/common/MultiSelect";
import SingleSelectFilter from "src/components/common/SingleSelectFilter";
import SearchBar from "src/components/common/SearchField";
import { usePersistedFilters } from "src/hooks/usePersistedFilters";
import { useLandOwnershipEntityOptions } from "src/hooks/useLandOwnershipEntityOptions";

import {
  statusMessages2,
  dprStatusMessages,
  detailedProjectTab,
} from "src/constants/common";
//import { tableColumns } from "src/constants/tableColumns";
import {
  getAllProjectsData,
  refetchAllProjects,
} from "src/redux/slices/dashboard/projects";
import EmptyView from "src/components/common/EmptyView";
import { getAllRegistration } from "src/utils/api/dashboard";
import { getStates } from "src/utils/api/roles";
import { dateAndTimeStamp, downloadSheet, formatINR } from "src/utils/helper";
import { RenderUploadDPRButton, RenderMOUButton } from "./RenderComponent";
import { path } from "src/constants/path";
import DataGrid from "src/components/common/DataGrid";
import { getStyles } from "src/styles/theme";
import defaultStyles, { StylesClasses } from "./styles";
import { useAppSelector } from "src/redux/store";
type RegistrationType = "registeredEntity" | "registeredLands";

const DetailedProjectReport = () => {
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const tab = searchParams.get("currentTab");
  const { persisted, saveFilters } = usePersistedFilters("dpr");
  const resolveTabValue = (value?: string | null) =>
    value && detailedProjectTab.some((item) => item.value === value)
      ? value
      : detailedProjectTab[0].value;

  const initialTab = resolveTabValue(tab ?? persisted?.activeTab);
  const [activeTab, setActiveTab] = useState(initialTab);
  const [states, setStates] = useState<any>([]);
  const [projectData, setProjectData] = useState<any>({
    count: 0,
    rows: [],
  });
  const [entityActiveTab, setEntityActiveTab] = useState(initialTab);

  const styles = getStyles<StylesClasses>(defaultStyles);

  const [queryParams, setQueryParams] = useState<{
    status: any;
    dprStatus: any;
    offset: number;
    limit: number;
    sortBy: string;
    searchText: string;
    projectStateIds?: string[];
    download: boolean;
    entityIds?: string[];
    newSelection: any;
  }>({
    status: undefined,
    dprStatus: activeTab,
    offset: persisted?.queryParams?.offset ?? 0,
    limit: 50,
    sortBy: persisted?.queryParams?.sortBy ?? "updated_at:DESC",
    searchText: persisted?.queryParams?.searchText ?? "",
    projectStateIds: persisted?.queryParams?.projectStateIds ?? undefined,
    download: false,
    entityIds: persisted?.queryParams?.entityIds ?? undefined,
    newSelection: 1,
  });

  const [filterKey, setFilterKey] = useState(
    persisted?.filterKey ?? { projectStateIds: null },
  );

  const [entityfilterKey, entitySetFilterKey] = useState(
    persisted?.entityFilterKey ?? { enetityStateIds: null },
  );

  useEffect(() => {
    const { download, ...qp } = queryParams;
    saveFilters({
      queryParams: qp,
      filterKey,
      entityFilterKey: entityfilterKey,
      activeTab: entityActiveTab,
    });
  }, [queryParams, filterKey, entityfilterKey, entityActiveTab]);

  useQuery(["getStatesType"], () => getStates(), {
    onSuccess: (data) => {
      setStates(data.data);
    },
    refetchOnMount: true,
  });

  const { isFetching: isEntityFetching } = useQuery(
    ["projects", queryParams],
    () =>
      getAllRegistration({
        ...queryParams,
        stateIds: queryParams?.projectStateIds
          ? queryParams?.projectStateIds.join(",")
          : undefined,
      }),
    {
      onSuccess: (data) => {
        dispatch(getAllProjectsData(data.data?.rows));
        const rows = data?.data?.rows?.map((row) => ({
          data: row,
          sno: row?.serialNo,
          id: row.id,
          status: row.status,
          rawDprStatus: row.dprStatus || null,
          dprStatus: row.dprStatus
            ? dprStatusMessages[row.dprStatus] ?? row.dprStatus
            : dprStatusMessages[row.status] ?? row.status,
          entityName: row?.user?.firstName,
          netPlantationArea: row?.netPlantationArea ?? "-",
          registrationNo: row.registrationNo,
          state: row.state,
          district: row.district,
          division: row?.division,
          allocatedivision:
            row?.projectDetail?.organizationAffiliationDetail?.userDetail
              ?.division,
          range: row?.projectDetail?.landSpecification?.range,
          treeCanopy: row?.treeCannopyDensity ?? "-",
          landArea: row?.projectDetail?.landArea,
          areaUnit: `${row.totalArea}`,
          demandNote: formatINR(row.demandNote) ?? "-",
          estimateAmount: row.demandNote
            ? formatINR(
                +`${Number(row?.demandNote)}` + +`${Number(row?.icfreCharges)}`,
              )
            : "-",
          totalAmountRecived: formatINR(row.amountPaid) ?? "-",
          ecoRestorationCostRecived: formatINR(row.ecoRestorationCost) ?? "-",
          adminChargesRecived: formatINR(row.adminCharges) ?? "-",
          remark: row.remark,
          created_at: dateAndTimeStamp(row?.created_at, "IST"),
          updated_at: dateAndTimeStamp(row.updated_at, "IST"),
        }));

        if (queryParams.download) {
          interface ExportItem {
            "S.NO"?: any;
            EPID?: any;
            "Registration No"?: any;
            "Entity Name"?: any;
            State?: any;
            District?: any;
            Division?: any;
            "Allocate Division"?: any;
            Range?: any;
            "Total Area"?: any;
            "Selected Area"?: any;
            Remark?: any;
            "Created At"?: any;
            "Updated At"?: any;
            Status?: any;
            "Final Area"?: any;
            "Tree Canopy Density"?: any;
            Eco_Restoration_Cost?: any;
            DemandNote_Amount?: any;
            "Total Amount Received"?: any;
            "Eco-Restoration Cost Received"?: any;
            "Admin Charges Received"?: any;
          }

          const exportData: ExportItem[] = rows.map((item) => {
            const status = statusMessages2[item?.status] ?? item?.status;
            const data: ExportItem = {
              "S.NO": item?.sno,
              EPID: item?.id,
              "Registration No": item?.registrationNo,
              "Entity Name": item?.entityName,
              State: item?.state,
              District: item?.district,
              Division: item?.division,
              "Allocate Division": item?.allocatedivision,
              Range: item?.range,
              "Tree Canopy Density": item?.treeCanopy,
              "Total Area": item?.landArea,
              "Selected Area": item?.areaUnit,
              "Final Area": item?.netPlantationArea,
              "Created At": item?.created_at,
              "Updated At": item?.updated_at,
              "Total Amount Received": item?.totalAmountRecived,
              "Eco-Restoration Cost Received": item.ecoRestorationCostRecived,
              "Admin Charges Received": item.adminChargesRecived,
            };

            if (status === "UNDER_QUERY" || status === "VERIFICATION_PENDING") {
              // Exclude eco_restoration_cost and demandNote_Amount
              data.Eco_Restoration_Cost = "-";
              data.DemandNote_Amount = "-";
            } else {
              // Include eco_restoration_cost and demandNote_Amount
              data.Eco_Restoration_Cost = item?.demandNote ?? "-";
              data.DemandNote_Amount = item?.estimateAmount ?? "-";
            }

            data.Status = item?.dprStatus;
            data.Remark = item?.remark;

            return data;
          });

          downloadSheet(exportData);
          setQueryParams((prev) => ({
            ...prev,
            download: false,
          }));
        } else {
          setProjectData({
            count: data?.data.count,
            rows,
          });
        }
      },
      refetchOnMount: true,
    },
  );

  const RenderEPID = (params) => {
    return (
      <>
        <Box
          component={RouterLink}
          to={`${path.landOwnershipDetails}?${createSearchParams({
            id: params?.id,
          })}`}
          sx={{
            ...defaultStyles.renderButtonText,
            color: "#36B1A0",
            fontWeight: 500,
            textDecoration: "none",
          }}
        >{`${params?.row?.id}`}</Box>
      </>
    );
  };

  const { entityInfo } = useLandOwnershipEntityOptions({
    dprStatus: queryParams.dprStatus,
    newSelection: queryParams.newSelection,
    stateIds: queryParams.projectStateIds?.join(","),
    searchText: queryParams.searchText,
  });

  const handleDprStatusChange = (value: RegistrationType) => {
    dispatch(refetchAllProjects(true));
    setActiveTab(value);
    setEntityActiveTab(value);
    navigate(
      `${path.detailedProjectReport}${value ? `?currentTab=${value}` : ""}`,
    );
    setQueryParams({
      ...queryParams,
      dprStatus: value,
      status: undefined,
      offset: 0,
    });
  };

  const tableColumns = [
    {
      field: "sno",
      headerName: "S.No",
      width: 90,
      sortable: false,
      tab: [],
    },
    {
      field: "id",
      headerName: "ID",
      width: 200,
      sortable: false,
      renderCell: RenderEPID,
      tab: [],
    },
    {
      field: "registrationNo",
      headerName: "Reg.No",
      width: 100,
      sortable: false,
      tab: [],
    },

    {
      field: "dpr",
      headerName: "Status",
      width: 150,
      sortable: false,
      renderCell: RenderUploadDPRButton,
    },
    {
      field: "entityName",
      headerName: "Entity Name",
      width: 200,
      sortable: false,
    },
    {
      field: "state",
      headerName: "State",
      width: 200,
      sortable: false,
    },
    {
      field: "district",
      headerName: "District",
      width: 200,
      sortable: false,
    },
    {
      field: "division",
      headerName: "Forest Division",
      width: 200,
      sortable: false,
    },
    {
      field: "range",
      headerName: "Range",
      width: 200,
      sortable: false,
      tab: [],
    },
    // {
    //   field: "treeCanopy",
    //   headerName: "Tree Canopy Density",
    //   width: 200,
    //   sortable: false,
    //   tab: [],
    // },
    {
      field: "areaUnit",
      headerName: "Selected Area",
      width: 200,
      sortable: false,
      tab: [],
    },
    {
      field: "landArea",
      headerName: "Total Area",
      width: 200,
      sortable: false,
      tab: [],
    },
    {
      field: "created_at",
      headerName: "CREATED AT",
      width: 250,
      sortable: false,
      tab: [],
    },
    {
      field: "updated_at",
      headerName: "UPDATED AT",
      width: 250,
      sortable: true,
      tab: [],
    },
    {
      field: "dprStatus",
      headerName: "STATUS",
      width: 250,
      sortable: false,
    },
    {
      field: "mou",
      headerName: "View/Upload MOU",
      width: 200,
      sortable: false,
      renderCell: RenderMOUButton,
    },
    {
      field: "remark",
      headerName: "Remark",
      width: 200,
      sortable: false,
      tab: [],
    },
  ];

  // const entitiesColumns = useMemo(
  //   () =>
  //     (tableColumns ?? []).map((item) => ({
  //       ...item,
  //       renderCell: item.renderCell ? Mapping[item.renderCell] : undefined,
  //     })),
  //   []
  // );

  const handlePagination = (page: any) => {
    dispatch(refetchAllProjects(true));
    setQueryParams({
      ...queryParams,
      offset: queryParams.limit * page,
    });
  };

  const handleSort = (sortByField) => {
    setQueryParams({
      ...queryParams,
      sortBy: `${sortByField[0]?.field}:${sortByField[0]?.sort.toUpperCase()}`,
    });
  };

  const exportToExcel = () => {
    setQueryParams({
      ...queryParams,
      download: true,
    });
  };

  const exportToExcel2 = () => {
    setQueryParams({
      ...queryParams,
      download: true,
    });
  };

  return (
    <DashboardWrapper
      title="Detailed Project Report"
      buttonIcon="/assets/svg/roundPlusIcon.svg"
      buttonText=""
      onButtonClick={() => {}}
      showBtn={!!projectData.rows.length}
    >
      <>
        <Box
          sx={{
            display: "flex",
            alignItems: "baseline",
            gap: "2%",
            padding: "10px 1%",
            background: "white",
            borderTopLeftRadius: "8px",
            borderTopRightRadius: "8px",
          }}
        >
          <SearchBar
            placeHolder="Search by Registration Number"
            defaultValue={persisted?.queryParams?.searchText || ""}
            getText={(e) => {
              setQueryParams((a) => {
                return { ...queryParams, searchText: `${e}` };
              });
            }}
          />
          <SingleSelectFilter
            label="Filter By Status"
            options={detailedProjectTab}
            value={entityActiveTab}
            onChange={handleDprStatusChange}
          />
          <MultiSelect
            options={states}
            value={filterKey.projectStateIds}
            onChange={(e: any) => {
              setFilterKey((prevFilter) => {
                const newState = {
                  ...prevFilter,
                  projectStateIds: e.length ? e : null,
                };

                setQueryParams({
                  ...queryParams,
                  projectStateIds: newState?.projectStateIds,
                });

                return newState;
              });
            }}
          />
          <MultiSelect
            options={entityInfo}
            label={"Filter By Entity"}
            clearable
            value={entityfilterKey.entityIds}
            onChange={(e: any) => {
              entitySetFilterKey((prevFilter) => {
                const newState = {
                  ...prevFilter,
                  entityIds: e.length ? e : null,
                };
                setQueryParams({
                  ...queryParams,
                  entityIds: newState?.entityIds,
                  offset: 0,
                });
                return newState;
              });
            }}
          />
          <Button onClick={exportToExcel2} text={"Export"} />
        </Box>
        <HorizontalTabs
          tabHeaders={detailedProjectTab}
          tabIndex={detailedProjectTab.findIndex(
            (item) => item.value === entityActiveTab,
          )}
          onChange={handleDprStatusChange}
          components={[<></>, <></>]}
        />
        {/* Data Grid */}
        {isEntityFetching ? (
          <HomeTableSkeleton showTabs={false} columns={8} />
        ) : projectData.rows.length > 0 ? (
          <DataGrid
            rows={projectData.rows}
            columns={tableColumns}
            rowCount={projectData.rows.length}
            rowsPerPageOptions={[10]}
            sortingMode="server"
            onSortModelChange={handleSort}
            paginationMode="client"
            pageSize={50}
            columnBuffer={20}
            loading={isEntityFetching}
            getRowId={(row) => row.id}
          />
        ) : (
          <EmptyView
            heading="No Entry Found"
            subheading=""
            onClick={() => {}}
          />
        )}
      </>
    </DashboardWrapper>
  );
};

export default DetailedProjectReport;
